import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './styles/workspace.css';
import './styles/product.css';
import './styles/mobile-inputs.css';
import './styles/refinements.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
